module.exports = __webpack_public_path__ + "static/img/icon_game_6.7864e73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_6.png
// module id = 64Mn
// module chunks = 0